/**
 * CrossMark mark: M5.T1.
 *
 * Hand-drawn X, used as a "wrong" indicator alongside the --urgent
 * color token (red flash on wrong guess / urgent timer).
 */
export function CrossMark({ size = 16 }: { size?: number }) {
  return (
    <svg class="mark-cross" viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
      <path
        d="M 3 2.5 C 5.5 5.5 8 8 13 13"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M 13 3 C 10 6 7 9 3 13"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
